<template>
    <div
        :class="[{'vs-sidebar-item-active':activeLink}, {'disabled-item pointer-events-none': isDisabled}]"
        class="vs-sidebar--item"
    >
        <router-link
            v-if="to"
            :to="to"
            :class="[{'router-link-active': activeLink}]"
            :target="target"
            exact
        >
            <span
                v-if="iconPack === 'fas'"
                class="sidebar-fa-icon"
                :style="activeLink ? 'color: white;' : 'color: #90a4ae;'"
            >
                <i :class="icon"></i>
            </span>
            <feather-icon v-else :icon="icon" :class="{'w-3 h-3': iconSmall}"></feather-icon>
            <slot></slot>
        </router-link>
        <a v-else :target="target" :href="href">
            <span
                v-if="iconPack === 'fas'"
                class="sidebar-fa-icon"
                :style="activeLink ? 'color: white;' : 'color: #90a4ae;'"
            >
                <i :class="icon"></i>
            </span>
            <feather-icon v-else :icon="icon" :class="{'w-3 h-3': iconSmall}"></feather-icon>
            <slot></slot>
        </a>
    </div>
</template>

<script>
export default {
    name: 'VxSidebarItem',
    props: {
        icon: {
            default: '',
            type: String,
        },
        iconSmall: {
            default: false,
            type: Boolean,
        },
        iconPack: {
            default: null,
            type: String,
        },
        href: {
            default: '#',
            type: String,
        },
        to: {
            default: null,
            type: String,
        },
        index: {
            default: null,
            type: [String, Number],
        },
        target: {
            default: '_self',
            type: String,
        },
        isDisabled: {
            default: false,
            type: Boolean,
        },
    },
    data() {
        return {
            activeLink: false,
        };
    },
    watch: {
        $route() {
            this.CheckIsActive();
        },
    },
    methods: {
        CheckIsActive() {
            if (this.to) {
                const meta = this.$router.currentRoute.meta;
                this.activeLink = this.to === meta.rootUrl;
            }
        },
    },
    updated() {
        this.CheckIsActive();
    },
};
</script>
